<template>
  <v-col cols="12">
    <v-row>
      <v-col v-for="card in cards" :key="card.key" cols="12" md="3">
        <IndustrialPanel v-if="!loading" :overline="card.overline">
          <template v-slot:title>
            <v-icon small class="mr-1">{{ card.icon }}</v-icon>{{ card.title }}
          </template>
          <template v-slot:subtitle>{{ card.subtitle }}</template>
          <div class="text-right mono-value kpi-value" v-if="card.values.length > 0">
            {{ formatNumber(card.values[card.values.length - 1]) }}
            <span class="kpi-unit">{{ card.unit }}</span>
          </div>
          <div class="text-caption text-right text--secondary">
            {{ $dayjs(energyValue.date).format('DD/MM/YYYY HH:mm') }}
          </div>
          <SMALL_CHART :category="card.labels" :data="card.values" class="mt-2" />
          <div class="text-center text-caption text--secondary mt-1">แนวโน้มการใช้พลังงาน 7 วันล่าสุด</div>
        </IndustrialPanel>
        <v-skeleton-loader v-else class="mx-auto" type="card" />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import SMALL_CHART from '@/components/energy_management/energy_summary_small_chart.vue'
import IndustrialPanel from '@/components/common/IndustrialPanel.vue'

export default {
  props: {
    meter: {
      type: Array
    },
  },
  components: {
    SMALL_CHART,
    IndustrialPanel,
  },
  data() {
    return {
      loading: true
    }
  },
  watch: {
    meter(value) {
      if (value && value.length > 0) {
        this.getDailyEnergy()
      } else {
        this.loading = true
      }
    },
    building() {
      this.getDailyEnergy()
    }
  },
  mounted() {
    this.getDailyEnergy();
  },
  computed: {
    building: {
      get() {
        return this.$store.state.User.building
      },
      set(newValue) {
        this.$store.dispatch('User/SET_BUILDING', newValue)
      }
    },
    energyValue: {
      get() {
        return this.$store.state.Energy.dailyEnergy
      },
    },
    energyPeakValue() {
      return this.energyValue.map(a => Number(a.Peak).toFixed(0))
    },
    energyPeakLabel() {
      return this.energyValue.map(a => a.date)
    },
    energyOffPeakValue() {
      return this.energyValue.map(a => Number(a.OffPeak).toFixed(0))
    },
    energyOffPeakLabel() {
      return this.energyValue.map(a => a.date)
    },
    energyUnitValue() {
      return this.energyValue.map(a => Number(a.Unit).toFixed(0))
    },
    energyUnitLabel() {
      return this.energyValue.map(a => a.date)
    },
    energyDemandValue() {
      return this.energyValue.map(a => Number(a.demand).toFixed(0))
    },
    energyDemandLabel() {
      return this.energyValue.map(a => a.date)
    },
    cards() {
      return [
        {
          key: 'total',
          overline: 'ENERGY',
          icon: 'mdi-sigma',
          title: 'Total Energy Usage',
          subtitle: 'การใช้พลังงานรวมประจำวัน',
          values: this.energyUnitValue,
          labels: this.energyUnitLabel,
          unit: 'kWh',
        },
        {
          key: 'onpeak',
          overline: 'ON-PEAK',
          icon: 'mdi-arrow-top-right',
          title: 'On-Peak',
          subtitle: 'การใช้พลังงานช่วง On-Peak ประจำวัน',
          values: this.energyPeakValue,
          labels: this.energyPeakLabel,
          unit: 'kWh',
        },
        {
          key: 'offpeak',
          overline: 'OFF-PEAK',
          icon: 'mdi-arrow-bottom-right',
          title: 'Off-Peak',
          subtitle: 'การใช้พลังงานช่วง Off-Peak ประจำวัน',
          values: this.energyOffPeakValue,
          labels: this.energyOffPeakLabel,
          unit: 'kWh',
        },
        {
          key: 'demand',
          overline: 'DEMAND',
          icon: 'mdi-delta',
          title: 'Peak Demand',
          subtitle: 'ค่าความต้องการใช้พลังงานสูงสุด',
          values: this.energyDemandValue,
          labels: this.energyDemandLabel,
          unit: 'kW',
        },
      ]
    },
  },
  methods: {
    formatNumber(val) {
      return Number(val).toLocaleString(undefined, { maximumFractionDigits: 0 })
    },
    getDailyEnergy() {
      if (this.meter.length > 0) {
        this.loading = true
        const start = this.$dayjs().local().subtract(7, 'day').unix() * 1000
        const end = this.$dayjs().local().endOf('day').unix() * 1000
        this.$store.dispatch('Energy/GET_DAILY_ENERGY', {
          BuildingId: this.building.BuildingId,
          type: 'daily',
          assetId: this.meter.map(a => a.assetId),
          start,
          end,
          group: true,
        }).then(() => {
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>
.kpi-value {
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  line-height: 1.2;
}

.kpi-unit {
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-muted, #6B7280);
}
</style>
